import {useCallback} from 'react';

import {RolesAccount} from '@/app/auth';
import {ADD_TEEN_EVENTS} from '@/app/auth/events/AddTeenEvents';
import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';

export const useTrackers = () => {
  const {trackEvent} = useTrackingManager();

  const trackApiSkipAddKidSwitchable = useCallback(
    (kidUuid: string) => {
      trackEvent(ADD_TEEN_EVENTS.API_SKIP_ADD_KID_SWITCHABLE, {
        project_tag: PROJECT_TAGS.ONBOARDING,
        FamilyMember: {
          id: kidUuid,
          role: RolesAccount.TEEN,
          no_phone: true,
        },
      });
    },
    [trackEvent],
  );

  const trackApiSuccessAddKid = useCallback(
    (kidUuid: string, noPhone: boolean) => {
      trackEvent(ADD_TEEN_EVENTS.API_ADD_KID_SUCCESS, {
        project_tag: PROJECT_TAGS.ONBOARDING,
        FamilyMember: {
          id: kidUuid,
          role: RolesAccount.TEEN,
          no_phone: noPhone,
        },
      });
    },
    [trackEvent],
  );

  const trackApiErrorAddKid = useCallback(
    (error: any, noPhone: boolean) => {
      trackEvent(
        ADD_TEEN_EVENTS.API_ADD_KID_ERROR,
        {
          project_tag: PROJECT_TAGS.ONBOARDING,
          FamilyMember: {
            role: RolesAccount.TEEN,
            no_phone: noPhone,
          },
        },
        error,
      );
    },
    [trackEvent],
  );

  const trackApiErrorAddKidMatchExisting = useCallback(
    (error: any) => {
      trackEvent(
        ADD_TEEN_EVENTS.API_ADD_KID_MATCH_EXISTING_KID_ERROR,
        {
          project_tag: PROJECT_TAGS.ONBOARDING,
          FamilyMember: {
            role: RolesAccount.TEEN,
          },
        },
        error,
      );
    },
    [trackEvent],
  );

  const trackApiAddKidFamilyCodeError = useCallback(
    (invitationCode: string, error: any) => {
      trackEvent(
        ADD_TEEN_EVENTS.API_ADD_KID_FAMILY_CODE_ERROR,
        {
          project_tag: PROJECT_TAGS.ONBOARDING,
          FamilyMember: {
            role: RolesAccount.TEEN,
          },
          Invitation: {
            code: invitationCode,
            written: true,
          },
        },
        error,
      );
    },
    [trackEvent],
  );

  const trackApiAddKidFamilyCodeSuccess = useCallback(
    (invitationCode: string) => {
      trackEvent(ADD_TEEN_EVENTS.API_ADD_KID_FAMILY_CODE_SUCCESS, {
        project_tag: PROJECT_TAGS.ONBOARDING,
        FamilyMember: {
          role: RolesAccount.TEEN,
        },
        Invitation: {
          code: invitationCode,
          written: true,
        },
      });
    },
    [trackEvent],
  );

  return {
    trackApiErrorAddKid,
    trackApiSuccessAddKid,
    trackApiErrorAddKidMatchExisting,
    trackApiAddKidFamilyCodeError,
    trackApiAddKidFamilyCodeSuccess,
    trackApiSkipAddKidSwitchable,
  };
};
